var angular = require('angular');
var _module = angular.module('listreports.start', []);


require('../events');

_module.requires.push('listreports.events');


_module.controller('StartController', [
    '$log',
    '$scope',
    '$events',

    function($log, $scope, $events) {
        $log.debug('Start Controller');

        // $scope Functions
        $scope.exploreProperty = function() {
            $events.track('Explore Click');
            $scope.go('main-menu');
        };
    }
]);


module.exports = _module;
